import { v4 } from 'uuid'
import { DotDensitySize } from '../../../mixins/enumManager'
import { EventHandler, EventEmitter } from '../../../mixins/eventHandler'
import { ColorPalette } from '../../../mixins/colorPalette'
import { LegendBuilder } from '../../legend/legendBuilder'
import { DataViz } from '../../../../service/DataViz'
import { Expression } from '../../../../service/Expression'
import { Layer } from '../../../../service/Layer'
import { Postgrest } from '../../../../service/Postgrest'
import { Postgresql } from '../../../../service/Postgresql'
import { QueryBuilder } from '../../../../service/QueryBuilder'
import mapActions from '../../../map/MapActions'
import Vue from 'vue'

class DataManager {
  constructor (options) {
    this.options = options
    this.dataVizService = DataViz.build({})
    this.expressionService = Expression.build({})
    this.layerService = Layer.build({})
    this.pgRestService = Postgrest.build({})
    this.pgSqlService = Postgresql.build({})
    this.queryService = QueryBuilder.build({})
    this.featureLayer = null
  }

  // region Fields
  get FeatureLayer () {
    return this.featureLayer
  }
  set FeatureLayer (value) {
    this.featureLayer = value
  }
  // endregion

  async addTargetLayer () {
    return new Promise((resolve, reject) => {
      const self = this
      const environment = Vue.prototype.$foundation.getEnvironmentId()
      this.getLayer(environment, this.options.layer.alias).then((layer) => {
        const classType = this.options.layer.type
        self.resolveStyle(layer).then((style) => {
          const options = {
            'mapKey': 'baseMap',
            'layer': layer.gdIdEvent,
            'promoteId': this.options.dataSource.relationalColumn,
            'resourceType': this.options.resourceType
          }
          if (classType === 'fill') { mapActions.addPolygonTheme(options, style) } else if (classType === 'circle' || classType === 'vector') { mapActions.addPointTheme(options, style) }
          resolve()
        }, (error) => {
          reject(error)
        })
      }, (error) => {
        reject(error)
      })
    })
  }
  async getBuckets () {
    return new Promise((resolve, reject) => {
      let customColors = []; let customValues = []
      const source = this.options.dataSource
      const self = this
      const environment = Vue.prototype.$foundation.getEnvironmentId()
      if (source.bins.count === 0) {
        resolve({
          buckets: customValues,
          customColors: customColors
        })
      }
      this.getLayer(environment, this.options.layer.featureLayer).then((layer) => {
        self.FeatureLayer = layer
        let model = {
          'aggregation': source.aggregation || 'none',
          'where': ((layer.cClass === 'filter' || layer.cClass === 'upload') && layer.jbQuery) ? layer.gdIdEvent : '',
          'groupBy': source.groupBy || ''
        }
        if (source.distributionMethod === 6) {
          source.bins.list.forEach(function (item) {
            customColors.push(item.color)
            customValues.push(parseFloat(item.max))
          })
        }
        self.expressionService.getBuckets(source.analyticColumn.id, source.bins.count, source.distributionMethod, model).then((res) => {
          if (res.status >= 200 && res.status < 300) {
            resolve({
              buckets: (source.distributionMethod === 6) ? customValues : res.data,
              customColors: customColors
            })
          } else {
            reject(new Error(res.data))
          }
        })
      }, (error) => {
        reject(error)
      })
    })
  }
  async getData () {
    return new Promise((resolve, reject) => {
      const source = this.options.dataSource
      const layer = this.FeatureLayer
      const model = {
        'aggregation': source.aggregation || 'none',
        'where': ((layer.cClass === 'filter' || layer.cClass === 'upload') && layer.jbQuery) ? layer.gdIdEvent : '',
        'expressions': source.expressions,
        'useAlias': false,
        'useInternalNames': true,
        'groupBy2': '',
        'groupBy': source.groupBy
      }
      this.expressionService.evaluateList(model).then((res) => {
        if (res.status >= 200 && res.status < 300) {
          resolve({
            bins: res.data
          })
        } else {
          reject(new Error(res.data))
        }
      })
    }, (error) => {
      console.log(error)
    })
  }
  async getFeatureLayer () {
    return new Promise((resolve, reject) => {
      const self = this
      const environment = Vue.prototype.$foundation.getEnvironmentId()
      this.getLayer(environment, this.options.layer.featureLayer).then((layer) => {
        self.FeatureLayer = layer

        self.getData().then((data) => {
          self.getBuckets().then((res) => {
            data.buckets = res.buckets
            data.customColors = res.customColors
            resolve(data)
          }, (error) => {
            reject(error)
          })
        }, (error) => {
          reject(error)
        })
      }, (error) => {
        reject(error)
      })
    })
  }
  async getLayer (environment, layerUid) {
    return new Promise((resolve, reject) => {
      this.layerService.getByUid(environment, layerUid).then((res) => {
        resolve(res.data[0])
      }, (error) => {
        reject(error)
      })
    })
  }
  async getStyle (layerUid, classType) {
    return new Promise((resolve, reject) => {
      this.dataVizService.getStyle(layerUid, classType).then((res) => {
        resolve(res.data)
      }, (error) => {
        reject(error)
      })
    })
  }
  async initialize () {
    return new Promise((resolve, reject) => {
      this.addTargetLayer().then((res) => {
        this.getFeatureLayer().then((res) => {
          resolve(res)
        }, (error) => {
          reject(error)
        })
      }, (error) => {
        reject(error)
      })
    })
  }
  async resolveStyle (layer) {
    return new Promise((resolve, reject) => {
      if (layer === undefined) reject(new Error('Esperado o parâmetro: layer'))
      if (this.options.hasOwnProperty('namedStyle') && this.options.namedStyle.length > 0) {
        this.dataVizService.getStyleByName(this.options.namedStyle).then((res) => {
          let style = res.data
          style.layout = style.layout || {}
          style.layout['visibility'] = this.options.visibility || 'visible'
          resolve(style)
        }, (error) => {
          reject(error)
        })
      } else {
        let classType = this.options.layer.type
        this.dataVizService.getStyle(layer.gdIdEvent, classType).then((res) => {
          let style = res.data
          style.layout = style.layout || {}
          style.minzoom = 0
          if (classType === 'circle') style.paint['circle-color'] = 'rgba(0,0,0,0)'
          if (classType === 'fill') style.paint['fill-outline-color'] = 'rgba(0,0,0,0)'
          style.layout['visibility'] = this.options.visibility || 'visible'
          resolve(style)
        }, (error) => {
          reject(error)
        })
      }
    })
  }
}

class FeatureStyleModifier extends EventHandler {
  // region Constructor
  constructor (map, layer, options) {
    if (typeof map === 'undefined') throw new Error('Esperada a instância de mapa')
    if (typeof layer === 'undefined') throw new Error('Esperado o alias do layer')
    if (typeof options === 'undefined') throw new Error('Parâmetro esperado: options')
    super()
    if (this.constructor === FeatureStyleModifier) {
      // Error Type 1. Abstract class can not be constructed.
      throw new TypeError('Can not construct abstract class.')
    }
    this._id = options.id || v4()
    this._options = options
    this._map = map
    this._layer = layer
    this._paint = []
    this._layout = []
    this._name = options.layer.name
    this._enabled = true
    this._expressions = []
    this._colorRange = []
    this._dataTable = []
    this._opacity = 0.7
    this._visible = true
    this._emitter = new EventEmitter()
    this._legendBuilder = new LegendBuilder(map)
    this._visibleRange = new VisibleRange(0, 24)
    this._visibleRangeEnabled = false
    this._colorPalette = new ColorPalette()
    this._relationalColumn = options.dataSource.relationalColumn || null
  }
  // endregion

  // region Fields
  get Alias () {
    return this._alias
  }
  set Alias (value) {
    this._alias = value
  }
  get ColorRange () {
    return this._colorRange
  }
  set ColorRange (value) {
    this._colorRange = value
  }
  get DataTable () {
    return this._dataTable
  }
  set DataTable (value) {
    this._dataTable = value
  }
  get Enabled () {
    return this._enabled
  }
  set Enabled (value) {
    this._enabled = value
  }
  get EventEmitter () {
    return this._emitter
  }
  get Expressions () {
    return this._expressions
  }
  set Expressions (value) {
    this._expressions = value
  }
  get HasNumericNull () {
    return this._hasNumericNull
  }
  set HasNumericNull (value) {
    this._hasNumericNull = value
  }
  get Id () {
    return this._id
  }
  set Id (value) {
    this._id = value
  }
  get Layout () {
    return this._layout
  }
  set Layout (value) {
    this._layout = value
  }
  get LegendBuilder () {
    return this._legendBuilder
  }
  get Name () {
    return this._name
  }
  set Name (value) {
    this._name = value
  }
  get Opacity () {
    return parseFloat(this._opacity)
  }
  set Opacity (value) {
    this._opacity = parseFloat(value)
  }
  get Options () {
    return this._options
  }
  set Options (value) {
    this._options = value
  }
  get Paint () {
    return this._paint
  }
  set Paint (value) {
    this._paint = value
  }
  get RelationalColumn () {
    return this._relationalColumn
  }
  get Visible () {
    return this._visible
  }
  get VisibleRange () {
    return this._visibleRange
  }
  set VisibleRange (value) {
    this._visibleRange = value
  }
  get VisibleRangeEnabled () {
    return this._visibleRangeEnabled
  }
  set VisibleRangeEnabled (value) {
    this._visibleRangeEnabled = value
  }
  // endregion

  // region Methods

  AttachMap (map) {
    this._map = map
  }

  DetachMap () {
    this._map = null
  }

  Destroy () {
    // TODO verificar uso adequado de métodos estáticos no ES6 (Ferraz)
    /* if (this === FeatureStyleModifier) {
      // Error Type 2. Abstract methods can not be called directly.
      throw new TypeError("Can not call static abstract method foo.");
    } else if (this.Destroy === FeatureStyleModifier.Destroy) {
      // Error Type 3. The child has not implemented this method.
      throw new TypeError("Please implement static abstract method Destroy");
    } else {
      // Error Type 5. The child has implemented this method but also called `super.foo()`.
      throw new TypeError("Do not call static abstract method Destroy from child.");
    } */
    this._map = null
    this._paint = null
    this._layout = null
    this._visibleRange = null
  }

  GetDataViz (layerId) {
    return this.Options.resourceType
    /*
    if (typeof layerId === 'undefined') layerId = this._layer
    if (this._map.getLayer(`cluster-${layerId}`)) return "vector"
    if (this._map.getLayer(`heatmap-${layerId}`)) return "vector"
    if (this._map.getLayer(`thematic-${layerId}`)) return "thematic"
    if (this._map.getLayer(`vector-${layerId}`)) return "vector"
    if (this._map.getLayer(`fill-${layerId}`)) return "fill"
    if (this._map.getLayer(`filter-${layerId}`)) return "filter"
    return "label"
    */
  }

  GetUniqueValues (value, index, self) {
    return self.indexOf(value) === index
  }

  AddLegend () {
    let legend = JSON.parse(JSON.stringify(this.Options.legend))
    if (!legend.enabled) return
    if (this instanceof RangedTheme) {
      legend.data = {domain: this.Buckets, values: this.DataTable, colors: this.ColorRange}
    } else if (this instanceof IndividualValueTheme) {
      const distinctValues = [...new Set(this.DataTable.map(x => x[this._expression]))]
      legend.data = {domain: distinctValues, values: this.DataTable, colors: this.ColorRange}
    } else {
      throw new Error(`Legenda sem tratamento`)
    }
    this._legendBuilder.render(this.Id, legend)
  }

  RemoveFeatureLayer () {
    let layerId = `theme-${this.Options.layer.alias}`
    let sourceId = `source-theme-${this.Options.layer.alias}`
    this._map.removeLayer(layerId)
    this._map.removeSource(sourceId)
  }

  RemoveFeatureState () {
    // region Variables
    const datavis = this.GetDataViz()
    const mapLayer = this._map.getLayer(`${datavis}-${this._layer}`)
    const layerId = this._layer
    // const sourceId = `source-${mapLayer.type}-${layerId}`
    const sourceId = mapLayer.source

    if (!this._map.getSource(sourceId)) {
      console.log(`source "${sourceId}" não foi encontrada`)
      return
    }
    // endregion

    this._map.removeFeatureState({
      source: sourceId,
      sourceLayer: layerId
    })
  }

  RemoveLegend () {
    if (this.Options.legend.enabled) {
      this.Options.legend.container = null
      const mapId = this._map.getContainer().id
      const legendId = `${mapId}-legend-${this.Id}`
      this._legendBuilder.remove(legendId)
    }
  }

  SetFeatureState (analyticColumn) {
    // region Validation
    if (!Array.isArray(this.DataTable)) throw new Error("O parâmetro 'data' deve ser um array")
    if (typeof analyticColumn === 'undefined') throw new Error("Esperado o parâmetro 'analyticColumn'")
    if (!this.RelationalColumn) throw new Error("Esperada a coluna relacional: 'relationalColumn'")
    // endregion

    // region Variables
    const dataViz = this.GetDataViz()
    const layerId = this._layer
    const mapLayer = this._map.getLayer(`${dataViz}-${layerId}`)
    const sourceId = mapLayer.source
    // endregion

    try {
      const self = this
      this.DataTable.forEach(function (row) {
        let values = {}
        values[analyticColumn] = row[analyticColumn]
        self._map.setFeatureState({
          source: sourceId,
          sourceLayer: layerId,
          id: row[self.RelationalColumn]
        }, values)
      })
    } catch (e) {
      console.log(e)
    }
  }

  WriteLayoutProperty (name, value) {
    if (!this._map) return null
    try {
      const datavis = this.GetDataViz()
      return this._map.setLayoutProperty(`${datavis}-${this._layer}`, name, value)
    } catch (e) {
    }
  }

  WritePaintProperty (name, value, options = {}) {
    if (!this._map) return null
    try {
      const datavis = this.GetDataViz()
      return this._map.setPaintProperty(`${datavis}-${this._layer}`, name, value, options)
    } catch (e) {
    }
  }

  // endregion
}

class ObjectTheme {
  constructor (map, layer, options) {
    this.expression = options.dataSource.expression
    this.options = options
    this.map = map
    this.layer = layer
    this.emitter = new EventEmitter()
    this.legendBuilder = new LegendBuilder(map)
    this.opacity = options.circleOpacity || 0.7
  }

  get DataTable () {
    return this.dataTable
  }
  set DataTable (value) {
    this.dataTable = value
  }
  get EventEmitter () {
    return this.emitter
  }
  get Expression () {
    return this.expression
  }
  set Expression (value) {
    this.expression = value
  }
  get LegendBuilder () {
    return this.legendBuilder
  }
  get Opacity () {
    return parseFloat(this.opacity)
  }
  set Opacity (value) {
    return this.opacity = parseFloat(value)
  }
  get Options () {
    return this.options
  }

  AttachMap (map) {
    this.map = map
  }

  Destroy () {

  }

  DetachMap () {
    this.map = null
  }

  GetDataViz (layerId) {
    if (typeof layerId === 'undefined') layerId = this.layer
    if (this.map.getLayer(`cluster-${layerId}`)) return 'vector'
    if (this.map.getLayer(`heatmap-${layerId}`)) return 'vector'
    if (this.map.getLayer(`thematic-${layerId}`)) return 'thematic'
    if (this.map.getLayer(`vector-${layerId}`)) return 'vector'
    if (this.map.getLayer(`fill-${layerId}`)) return 'fill'
    if (this.map.getLayer(`filter-${layerId}`)) return 'filter'
    return 'label'
  }

  SetFeatureState (data, analyticColumn, relationalColumn) {
    // region Validation
    if (typeof data === 'undefined') throw new Error("Esperado o parâmetro 'data'")
    if (!Array.isArray(data)) throw new Error("O parâmetro 'data' deve ser um array")
    if (typeof analyticColumn === 'undefined') throw new Error("Esperado o parâmetro 'analyticColumn'")
    if (typeof relationalColumn === 'undefined') throw new Error("Esperado o parâmetro 'relationalColumn'")
    // endregion

    // region Variables
    const dataViz = this.GetDataViz()
    const mapLayer = this.map.getLayer(`${dataViz}-${this.layer}`)
    const sourceId = mapLayer.source
    // endregion

    try {
      const self = this
      data.forEach(function (row) {
        let values = {}
        values[analyticColumn] = row[analyticColumn]
        self.map.setFeatureState({
          source: sourceId,
          sourceLayer: self.layer,
          id: row[relationalColumn]
        }, values)
      })
    } catch (e) {
      console.log(e)
    }
  }

  WriteLayoutProperty (name, value) {
    if (!this.map) return null
    try {
      const datavis = this.GetDataViz()
      return this.map.setLayoutProperty(`${datavis}-${this.layer}`, name, value)
    } catch (e) {
    }
  }

  WritePaintProperty (name, value, options = {}) {
    if (!this.map) return null
    try {
      const datavis = this.GetDataViz()
      return this.map.setPaintProperty(`${datavis}-${this.layer}`, name, value, options)
    } catch (e) {
    }
  }
}

class ModifierThemeBin {
  constructor () {
  }
  createBins (buckets, colors, useUpper = true) {
    // region Validation
    if (!buckets) throw new Error("Esperado o parâmetro 'buckets'")
    if (!colors) throw new Error("Esperado o parâmetro 'colors'")
    if (!Array.isArray(buckets)) throw new Error("Parâmetro 'buckets' deve ser um array de valores min/max")
    if (!Array.isArray(colors)) throw new Error("Parâmetro 'colors' deve ser um array de cores")
    // endregion

    let bins = []
    buckets.forEach(function (bucket, index) {
      if (useUpper) { bins.push([bucket.upper, `${colors[index]}`]) } else { bins.push([bucket.lower, `${colors[index]}`]) }
    })
    return bins
  }

  createBinsNew (buckets, colors) {
    // region Validation
    if (!buckets) throw new Error("Esperado o parâmetro 'buckets'")
    if (!colors) throw new Error("Esperado o parâmetro 'colors'")
    if (!Array.isArray(buckets)) throw new Error("Parâmetro 'buckets' deve ser um array de valores min/max")
    if (!Array.isArray(colors)) throw new Error("Parâmetro 'colors' deve ser um array de cores")
    // endregion
    let bins = buckets[0].map((min, index) => [min, buckets[1][index], colors[index]]);
    return bins;
  }
  createBins2 (buckets, colors) {
    // region Validation
    if (!buckets) throw new Error("Esperado o parâmetro 'buckets'")
    if (!colors) throw new Error("Esperado o parâmetro 'colors'")
    if (!Array.isArray(buckets)) throw new Error("Parâmetro 'buckets' deve ser um array de valores min/max")
    if (!Array.isArray(colors)) throw new Error("Parâmetro 'colors' deve ser um array de cores")
    // endregion
    let bins = []
    buckets.forEach(function (bucket, index) {
      bins.push([bucket, `${colors[index]}`])
    })
    return bins
  }
  createBins3 (colors, buckets) {
    // region Validation
    if (!buckets) throw new Error("Esperado o parâmetro 'buckets'")
    if (!colors) throw new Error("Esperado o parâmetro 'colors'")
    if (!Array.isArray(buckets)) throw new Error("Parâmetro 'buckets' deve ser um array de valores min/max")
    if (!Array.isArray(colors)) throw new Error("Parâmetro 'colors' deve ser um array de cores")
    // endregion
    let bins = []
    buckets.forEach(function (bucket, index) {
      bins.push([`${colors[index]}`, bucket])
    })
    return bins
  }
  createCircleRadius (column, stops, featureState = true) {
    // region Validation
    if (!column) throw new Error("Esperado o parâmetro 'column'")
    if (!stops) throw new Error("Esperado o parâmetro 'stops'")
    if (!Array.isArray(stops)) throw new Error("Parâmetro 'stops' deve ser um array de cores")
    // endregion
    // let interpolate = ['interpolate', ['linear'], ['coalesce',['get', column]]]
    let interpolate = ['interpolate', ['linear'], ['to-number', [featureState ? 'feature-state' : 'get', column]]]
    stops.forEach(function (stop) {
      interpolate.push(stop[0])
      interpolate.push(stop[1])
    })
    return interpolate
  }
  createDomainColors (colors) {
    // region Validation
    if (!colors) throw new Error("Esperado o parâmetro 'colors'")
    if (!Array.isArray(colors)) throw new Error("Parâmetro 'colors' deve ser um array de cores")
    // endregion
    let domain = []
    colors.forEach(function (color) {
      domain.push(`${color}`)
    })
    return domain
  }
  createDomainValues (buckets) {
    // region Validation
    if (!buckets) throw new Error("Esperado o parâmetro 'buckets'")
    if (!Array.isArray(buckets)) throw new Error("Parâmetro 'buckets' deve ser um array de valores min/max")
    // endregion

    if (buckets[0].hasOwnProperty('upper')) { return [buckets[0].lower, buckets[buckets.length - 1].upper] }
    return [buckets[0].lower, buckets[buckets.length - 1].lower]
  }
  createDomainValues2 (buckets, useUpper = true) {
    // region Validation
    if (!buckets) throw new Error("Esperado o parâmetro 'buckets'")
    if (!Array.isArray(buckets)) throw new Error("Parâmetro 'buckets' deve ser um array de valores min/max")
    // endregion
    let domain = []
    buckets.forEach(function (bucket) {
      domain.push((useUpper) ? bucket.upper : bucket.lower)
    })
    return domain
  }
  createFillColor(column, stops, featureState = true) {
      if (!column) throw new Error("Esperado o parâmetro 'column'");
      if (!stops || !Array.isArray(stops)) throw new Error("Parâmetro 'stops' deve ser um array de arrays");

      const caseExpression = ["case"];


        stops.forEach(([min,max, color],index) => {
          if (index === 0) {
              // Lógica para o primeiro stop
              caseExpression.push(
                ['all', ["<=", ['to-number', [featureState ? 'feature-state' : 'get', column]], max]], color
              );
          } else if (index === stops.length - 1) {
            // Lógica para o último stop
            caseExpression.push(
              ['all',['>', ['to-number', [featureState ? 'feature-state' : 'get', column]], min]], color
            );
          } else {
            // Lógica para os demais stops
            caseExpression.push(
              ['all',['>', ['to-number', [featureState ? 'feature-state' : 'get', column]], min], ["<=", ['to-number', [featureState ? 'feature-state' : 'get', column]], max]], color
            );
        }
        });
        // debugger;
        // Cor padrão se não se enquadrar em nenhum intervalo
        caseExpression.push('rgba(255, 255, 255, 0)');

        // return caseExpression;
        return ['case',
        ['!=', [featureState ? 'feature-state' : 'get', column], null],
        caseExpression,
        'rgba(255, 255, 255, 0)' // cor caso o valor seja null
      ]
  }
  /**
   * get CategoryParent
   *
   * @async
   * @function createFillColor2
   * @param {Array} buckets - Uma coleção de valores
   * @param {Array} colors - Uma coleção de cores
   * @param {String} column - Nome da coluna analítica
   * @param {Boolean} featureState - Indica se usa FeatureState ou uma coluna no GeoJson do mapa
   * @return {String} The MapBox style pattern
   */
  createFillColor2 (buckets = [], colors = [], column = '', featureState = true) {
    // region Validation
    if (buckets.length === 0) throw new Error("Parâmetro 'buckets' deve conter valores")
    if (colors.length === 0) throw new Error("Parâmetro 'colors' deve conter valores")
    // if (colors.length !== buckets.length) throw new Error("Buckets e Colors devem possuir o mesmo número de elementos")
    if (column.length === 0) throw new Error('Esperado o nome da coluna')
    // endregion
    const stops = this.createBins3(colors, buckets)
    let step = ['step', [featureState ? 'feature-state' : 'get', column]]
    stops.forEach(function (stop) {
      step.push(stop[0])
      step.push(stop[1])
    })
    step.push('rgba(255, 255, 255, 0)')
    return ['case',
      ['!=', [featureState ? 'feature-state' : 'get', column], null],
      step,
      'rgba(255, 255, 255, 0)'
    ]
  }
  createSingleFillColor (column, color = '#000000', featureState = true) {
    // region Validation
    if (!column) throw new Error("Esperado o parâmetro 'column'")
    // endregion
    return ['case',
      ['!=', [featureState ? 'feature-state' : 'get', column], null],
      color,
      'rgba(255, 255, 255, 0)'
    ]
  }
  createCategoricalFillColor (column, stops, featureState = true, nullsColor = 'rgba(255, 255, 255, 0)',  allOtherColor = '#000000') {
    // region Validation
    if (!column) throw new Error("Esperado o parâmetro 'column'")
    if (!stops) throw new Error("Esperado o parâmetro 'stops'")
    if (!Array.isArray(stops)) throw new Error("Parâmetro 'stops' deve ser um array de cores")
    // endregion
    // let match = ['match', [featureState ? 'feature-state' : 'get', column]]
    let match = ['case']
    stops.forEach(function (stop) {
      match.push(["==", [featureState ? 'feature-state' : 'get', column], stop[0] ==  "BRANCOS E/OU NULOS" ? null : stop[0] ])
      match.push(stop[1])
    })

    let outsideFilter = stops.filter(e => e[0] == 'TODAS AS OUTRAS')

    // Handle null or empty
    match.push(outsideFilter != undefined && outsideFilter.length != 0 ? outsideFilter[0][1] : allOtherColor)
    // Handle all others
    return match
  }
  /**
   * get CategoryParent
   *
   * @async
   * @function createCategoricalFillColor2
   * @param {Array} buckets - Uma coleção de valores
   * @param {Array} colors - Uma coleção de cores
   * @param {String} column - Nome da coluna analítica
   * @param {Boolean} featureState - Indica se usa FeatureState ou uma coluna no GeoJson do mapa
   * @return {String} The MapBox style pattern
   */
  createCategoricalFillColor2 (buckets = [], colors = [], column = '', featureState = true) {
    // region Validation
    if (buckets.length === 0) throw new Error("Parâmetro 'buckets' deve conter valores")
    if (colors.length === 0) throw new Error("Parâmetro 'colors' deve conter valores")
    // if (colors.length !== buckets.length) throw new Error("Buckets e Colors devem possuir o mesmo número de elementos")
    if (column.length === 0) throw new Error('Esperado o nome da coluna')
    // endregion
    const stops = this.createBins2(buckets, colors)
    let match = ['match', [featureState ? 'feature-state' : 'get', column]]
    stops.forEach(function (stop) {
      match.push(stop[0])
      match.push(stop[1])
    })
    match.push('rgba(255, 255, 255, 0)')
    return match
  }
  createCategoricalSymbols (column, stops, allOthers = 'art-gallery-15') {
    // region Validation
    if (!column) throw new Error("Esperado o parâmetro 'column'")
    if (!stops) throw new Error("Esperado o parâmetro 'stops'")
    if (!Array.isArray(stops)) throw new Error("Parâmetro 'stops' deve ser um array de símbolos")
    // endregion
    let match = ['case']
    stops.forEach(function (stop) {
      match.push(["==", ['get', column], stop[0] ==  "BRANCOS E/OU NULOS" ? null : stop[0] ])
      match.push(stop[1])
    })

    let outsideFilter = stops.filter(e => e[0] == 'TODAS AS OUTRAS')

    // Handle null or empty
    match.push(outsideFilter != undefined && outsideFilter.length != 0 ? outsideFilter[0][1] : allOthers)
    // Handle all others
    return match

  }
}

class DotDensityTheme extends FeatureStyleModifier {
  constructor (layer, expression, alias, color = '#000000', dotSize = DotDensitySize.Large) {
    super(null, alias)
    this._layer = layer
    this._expression = expression
    this._color = color
    this._dotSize = dotSize
  }
}

class GraduatedSymbolTheme extends ObjectTheme {
  constructor (map, layer, options) {
    super(map, layer, options)
    this.circleColor = options.circleColor || 'rgba(138,43,226 ,1 )'
    this.radiusFactor = 200
  }

  Apply () {
    try {
      const datavis = this.GetDataViz()
      const mapLayer = this.map.getLayer(`${datavis}-${this.layer}`)
      const layerType = mapLayer.type
      if (layerType === 'circle') {
        this.WritePaintProperty('circle-color', this.circleColor)
        this.WritePaintProperty('circle-opacity', this.Opacity)
        this.WritePaintProperty('circle-radius', ['max', ['/', ['sqrt', ['feature-state', this.Expression]], this.radiusFactor], 1])
      } else {
        throw new Error(`Tipo de layer não suportado: '${layerType}"`)
      }
    } catch (e) {
      throw e
    }
  }

  Destroy () {

  }
}

class IndividualValueTheme extends FeatureStyleModifier {
  constructor (map, layer, options) {
    super(map, layer, options)
    this._expression = options.dataSource.relationalColumn
    this._relationalColumn = options.dataSource.relationalColumn
    this._borders = options.borders || false
    this._opacity = options.opacity || 0.7
    this._bins = options.bins
    this._hasNumericNull = options.hasNumericNull || false
    this._allowEmptyString = options.allowEmptyString || true
    this._colorScheme = options.colorScheme || 'RdPu'
    this.modifierThemeBin = new ModifierThemeBin()
  }

  // region Fields
  get AllowEmptyString () {
    return this._allowEmptyString
  }
  set AllowEmptyString (value) {
    this._allowEmptyString = value
  }
  get Bins () {
    return this._bins
  }
  get Expression () {
    return this._expression
  }
  set Expression (value) {
    this._expression = value
  }
  get ColorScheme () {
    return this._colorScheme
  }
  set ColorScheme (value) {
    this._colorScheme = value
  }
  // endregion

  // region Methods
  Apply (foreColor) {
    try {
      const datavis = this.GetDataViz()
      const mapLayer = this._map.getLayer(`${datavis}-${this._layer}`)
      const layerType = mapLayer.type
      if (layerType === 'circle') {
        this.WritePaintProperty('circle-color', foreColor)
        this.WritePaintProperty('circle-opacity', this.Opacity)
        /* this.WritePaintProperty('circle-radius', {
          'base': 1.75,
          'stops': [
            [12, 2],
            [22, 180]
          ]
        }); */
      } else if (layerType === 'fill') {
        this.WritePaintProperty('fill-color', foreColor)
        this.WritePaintProperty('fill-opacity', this.Opacity)
        if (this.Borders) { this.WritePaintProperty('fill-outline-color', 'rgba(0,0,0,1)') } else { this.WritePaintProperty('fill-outline-color', 'rgba(0,0,0,0)') }
      } else if (layerType === 'line') {
        this.WritePaintProperty('line-color', foreColor)
        this.WritePaintProperty('line-opacity', this.Opacity)
      } else {
        throw new Error(`Tipo de layer não suportado: '${layerType}"`)
      }
    } catch (e) {
      throw e
    }
  }

  Destroy () {
    this.RemoveFeatureState()
    this.RemoveLegend()
    this._options = null
    delete this.modifierThemeBin
    super.Destroy()
  }

  Recompute () {
    try {
      /*
      const upperValue = d3Array.max(this._bins, function(d) {
        return d[self._expression];
      });
      const lowerValue = d3Array.min(this._bins, function(d) {
        return d[self._expression];
      });
      const domain = [lowerValue, upperValue];
      */
      const self = this
      const distinctValues = [...new Set(this.DataTable.map(x => x[this._expression]))]
      const randomColorOpts = {hue: 'random', luminosity: 'random', count: distinctValues.length, format: 'rgba'}
      this.ColorRange = this._colorPalette.randomColors(randomColorOpts)
      // this.Options.legend.data.domain = distinctValues
      const stops = this.modifierThemeBin.createBins2(distinctValues, this.ColorRange)
      const foreColor = this.modifierThemeBin.createCategoricalFillColor(this.Expression, stops, true)
      this.Apply(foreColor)
      this.AddLegend()
      this._emitter.trigger('themeChanged', {themeId: this.Id})
    } catch (e) {
      throw e
    }
  }

  RecomputeBins () {
    try {
      this.RemoveFeatureState()
      this.RemoveLegend()
      this.ColorRange = this._colorPalette.colorBrewerRamp(this.ColorScheme, this.Buckets.length)
      const stops = this.modifierThemeBin.createBins2(this.Buckets, this.ColorRange)
      const foreColor = this.modifierThemeBin.createFillColor(this.Expression, stops)
      this.Apply(foreColor)
      this.AddLegend()
      this._emitter.trigger('themeChanged', {themeId: this.Id})
    } catch (e) {
      console.log(e)
    }
  }

  RecomputeStyles () {
    try {
      this.RemoveFeatureState()
      this.RemoveLegend()
      this.ColorRange = this._colorPalette.colorBrewerRamp(this.ColorScheme, this.Buckets.length)
      const stops = this.modifierThemeBin.createBins2(this.Buckets, this.ColorRange)
      const foreColor = this.modifierThemeBin.createFillColor(this.Expression, stops)
      this.Apply(foreColor)
      this.AddLegend()
      this._emitter.trigger('themeChanged', {themeId: this.Id})
    } catch (e) {
      throw e
    }
  }

  toString () {
    delete this.Options.legend.data
    const serialize = {
      paint: this.Paint,
      layout: this.Layout,
      layer: this._layer,
      options: this.Options,
      classType: this.Options.classType
    }
    return JSON.stringify(serialize)
  }
  // endregion
}

/*
class BarTheme extends MultiVariableTheme {
  constructor() {
    super();
  }
}

class PieTheme extends MultiVariableTheme {
  constructor() {
    super();
  }
}
*/

class MultiVariableTheme extends ObjectTheme {
  constructor () {
    super(null, null, null)
  }
}

class FilterStyle extends FeatureStyleModifier {
  constructor (map, layer, options) {
    super(map, layer, options)
    this._expression = options.dataSource.relationalColumn
    this._relationalColumn = options.dataSource.relationalColumn
    this._borders = options.borders || false
    this._opacity = options.opacity || 0.7
    this._radius = options.radius || 5
    this._hasNumericNull = options.hasNumericNull || false
    this._color = options.color || 'rgba(0,0,0,1)'
    this.modifierThemeBin = new ModifierThemeBin()
  }

  // region Fields
  get Borders () {
    return this._borders
  }
  set Borders (value) {
    this._borders = value
  }
  get Color () {
    return this._color
  }
  set Color (value) {
    this._color = value
  }
  get Expression () {
    return this._expression
  }
  set Expression (value) {
    this._expression = value
  }
  get Radius () {
    return this._radius
  }
  // endregion

  // region Methods

  Apply (foreColor) {
    try {
      const datavis = this.GetDataViz()
      const mapLayer = this._map.getLayer(`${datavis}-${this._layer}`)
      const layerType = mapLayer.type
      if (layerType === 'circle') {
        this.WritePaintProperty('circle-color', foreColor)
        this.WritePaintProperty('circle-opacity', this.Opacity)
        this.WritePaintProperty('circle-radius', this.Radius)
      } else if (layerType === 'fill') {
        this.WritePaintProperty('fill-color', foreColor)
        this.WritePaintProperty('fill-opacity', this.Opacity)
        if (this.Borders) { this.WritePaintProperty('fill-outline-color', 'rgba(0,0,0,1)') } else { this.WritePaintProperty('fill-outline-color', 'rgba(0,0,0,0)') }
      } else if (layerType === 'line') {
        this.WritePaintProperty('line-color', foreColor)
        this.WritePaintProperty('line-opacity', this.Opacity)
      } else {
        throw new Error(`Tipo de layer não suportado: '${layerType}"`)
      }
    } catch (e) {
      throw e
    }
  }

  Destroy () {
    this.RemoveFeatureState()
    this.RemoveFeatureLayer()
    this.RemoveLegend()
    this._options = null
    delete this.modifierThemeBin
    super.Destroy()
  }

  Recompute () {
    try {
      const foreColor = this.modifierThemeBin.createSingleFillColor(this.Expression, this.Color)
      this.Apply(foreColor)
      this.AddLegend()
      this._emitter.trigger('filterChanged', {filterId: this.Id})
    } catch (e) {
      throw e
    }
  }

  // endregion
}

class RangedTheme extends FeatureStyleModifier {
  constructor (map, layer, options) {
    super(map, layer, options)
    this._expression = options.dataSource.relationalColumn
    this._relationalColumn = options.dataSource.relationalColumn
    this._borders = options.borders || false
    this._opacity = options.opacity || 0.7
    this._hasNumericNull = options.hasNumericNull || false
    this._invertColors = options.invertColors || false
    this._inflected = false
    this._colorScheme = options.colorScheme || 'RdPu'
    this._customColor = options.customColor || null
    this._distribution = options.dataSource.distributionMethod || 4
    this.modifierThemeBin = new ModifierThemeBin()
  }

  // region Fields
  get Borders () {
    return this._borders
  }
  set Borders (value) {
    this._borders = value
  }
  get Buckets () {
    return this.Options.buckets
  }
  set Buckets (value) {
    this.Options.buckets = value
  }
  get ColorScheme () {
    return this._colorScheme
  }
  set ColorScheme (value) {
    this._colorScheme = value
  }
  get CustomColor () {
    return this.Options.colorRange
  }
  set CustomColor (value) {
    this.Options.colorRange = value
  }
  get Distribution () {
    return this._distribution
  }
  get Expression () {
    return this.Options.dataSource.analyticColumn.name
  }
  set Expression (value) {
    this._expression = value
  }
  get Inflected () {
    return this._inflected
  }
  set Inflected (value) {
    this._inflected = value
  }
  get InvertColors () {
    return this._invertColors
  }
  set InvertColors (value) {
    this._invertColors = value
  }
  // endregion

  // region Methods
  Destroy () {
    this.RemoveFeatureState()
    this.RemoveFeatureLayer()
    this.RemoveLegend()
    // this._options = null
    // delete this.modifierThemeBin
    // super.Destroy()
  }

  Apply (foreColor) {
    try {
      const datavis = this.GetDataViz()
      const mapLayer = this._map.getLayer(`${datavis}-${this._layer}`)
      const layerType = mapLayer.type
      if (this._inflected) {
        // const colors = colorPalette.schemeBlues(this._bins.length);

      } else {
        if (layerType === 'circle') {
          this.WritePaintProperty('circle-color', foreColor)
          this.WritePaintProperty('circle-opacity', this.Opacity)
          /*
          this.WritePaintProperty('circle-radius', {
            'base': 1.75,
            'stops': [
              [12, 2],
              [22, 180]
            ]
          });
          */
        } else if (layerType === 'fill') {
          this.WritePaintProperty('fill-color', foreColor)
          this.WritePaintProperty('fill-opacity', this.Opacity)
          if (this.Borders) { this.WritePaintProperty('fill-outline-color', 'rgba(0,0,0,1)') } else { this.WritePaintProperty('fill-outline-color', 'rgba(0,0,0,0)') }
        } else if (layerType === 'line') {
          this.WritePaintProperty('line-color', foreColor)
          this.WritePaintProperty('line-opacity', this.Opacity)
        } else {
          throw new Error(`Tipo de layer não suportado: '${layerType}"`)
        }
      }
    } catch (e) {
      throw e
    }
  }

  Recompute () {
    try {
      let colorRange = (this.Distribution !== 6)
        ? this._colorPalette.colorBrewerRamp(this.ColorScheme, this.Buckets.length)
        : this.CustomColor
      if (this.InvertColors) {
        colorRange = colorRange.reverse()
      }
      this.ColorRange = colorRange
      const stops = this.modifierThemeBin.createBins2(this.Buckets, this.ColorRange)
      const foreColor = this.modifierThemeBin.createFillColor(this.Expression, stops)
      this.Apply(foreColor)
      this.AddLegend()
      this._emitter.trigger('themeChanged', {themeId: this.Id})
    } catch (e) {
      throw e
    }
  }

  RecomputeBins () {
    return new Promise((resolve, reject) => {
      const dataManager = new DataManager(this.Options)
      dataManager.getBuckets().then((res) => {
        this.Buckets = res.buckets
        this.CustomColor = res.customColors
        // this.DataTable = res.bins
        // this.SetFeatureState(res.bins, this.Options.dataSource.expression, this.Options.dataSource.relationalColumn)
        // this.Recompute()
        // this.LegendBuilder.DetachMap()
        // this.DetachMap()
        resolve(res)
      }, (error) => {
        reject(error)
      })
    })
  }

  RecomputeStyles () {
    try {
      // this.RemoveFeatureState()
      // this.RemoveLegend()
      this.ColorRange = this._colorPalette.colorBrewerRamp(this.ColorScheme, this.Buckets.length)
      const stops = this.modifierThemeBin.createBins2(this.Buckets, this.ColorRange)
      const foreColor = this.modifierThemeBin.createFillColor(this.Expression, stops)
      this.Apply(foreColor)
      // this.AddLegend()
      this._emitter.trigger('themeChanged', {themeId: this.Id})
    } catch (e) {
      throw e
    }
  }

  toString () {
    const serialize = {
      paint: this.Paint,
      layout: this.Layout,
      layer: this._layer,
      options: this.Options,
      classType: this.Options.classType
    }
    return JSON.stringify(serialize)
  }

  // endregion
}

class VisibleRange {
  constructor (rangeStart = 0, rangeEnd = 24) {
    this._rangeEnd = rangeEnd
    this._rangeStart = rangeStart
  }

  get RangeEnd () {
    return this._rangeEnd
  }
  set RangeEnd (value) {
    this._rangeEnd = value
  }
  get RangeStart () {
    return this._rangeStart
  }
  set RangeStart (value) {
    this._rangeStart = value
  }
}

class ThematicBuilder {
  constructor () {
    this.themes = []
  }

  addTheme (theme) {

  }
  createFilter (map, layer, options = {}) {
    return new Promise((resolve, reject) => {
      // region Validation
      if (typeof map === 'undefined') reject('O construtor precisa de uma instância de mapa')
      if (typeof layer === 'undefined') reject('O temático precisa de um alias de layer')
      if (typeof options !== 'object') reject('O temático precisa de opções')
      if (typeof options.layer.featureLayer === 'undefined') reject('Esperado o layer de referência')
      if (typeof options.dataSource.analyticColumn === 'undefined') reject('Esperada a coluna analítica')
      if (typeof options.dataSource.relationalColumn === 'undefined') reject('Esperada a coluna relacional')
      if (typeof options.legend === 'undefined') options.legend.enabled = false
      // endregion

      const dataManager = new DataManager(options)
      dataManager.initialize().then((res) => {
        const filter = new FilterStyle(map, layer, options)
        filter.DataTable = res.bins
        filter.SetFeatureState(filter.Expression)
        filter.Recompute()
        filter.LegendBuilder.DetachMap()
        filter.DetachMap()
        resolve(filter)
      }, (error) => {
        reject(error)
      })
    })
  }
  createGraduatedSymbolTheme (map, layer, options = {}) {
    return new Promise((resolve, reject) => {
      // region Validation
      if (typeof map === 'undefined') reject('O construtor precisa de uma instância de mapa')
      if (typeof layer === 'undefined') reject('O temático precisa de um alias de layer')
      if (typeof options !== 'object') reject('O temático precisa de opções')
      if (typeof options.layer.featureLayer === 'undefined') reject('Esperado o layer de referência')
      if (typeof options.dataSource.expression === 'undefined') reject('Esperada a expressão')
      if (typeof options.dataSource.relationalColumn === 'undefined') reject('Esperada a coluna relacional')
      if (typeof options.legend === 'undefined') options.legend.enabled = false
      // endregion

      const dataManager = new DataManager(options)
      dataManager.initialize().then((res) => {
        const theme = new GraduatedSymbolTheme(map, layer, options)
        theme.DataTable = res.bins
        theme.SetFeatureState(theme.Expression)
        theme.Apply()
        theme.LegendBuilder.DetachMap()
        theme.DetachMap()
        resolve(theme)
      }, (error) => {
        reject(error)
      })
    })
  }
  createIndividualValueTheme (map, layer, options = {}) {
    return new Promise((resolve, reject) => {
      // region Validation
      if (typeof map === 'undefined') reject('O construtor precisa de uma instância de mapa')
      if (typeof layer === 'undefined') reject('O temático precisa de um alias de layer')
      if (typeof options !== 'object') reject('O temático precisa de opções')
      if (typeof options.layer.featureLayer === 'undefined') reject('Esperado o layer de referência')
      if (typeof options.dataSource.analyticColumn === 'undefined') reject('Esperada a coluna analítica')
      if (typeof options.dataSource.relationalColumn === 'undefined') reject('Esperada a coluna relacional')
      if (typeof options.legend === 'undefined') options.legend.enabled = false
      // endregion

      const dataManager = new DataManager(options)
      dataManager.initialize().then((res) => {
        const theme = new IndividualValueTheme(map, layer, options)
        // theme.Buckets = res.buckets
        theme.DataTable = res.bins
        theme.SetFeatureState(theme.Expression)
        theme.Recompute()
        theme.LegendBuilder.DetachMap()
        theme.DetachMap()
        // self.addTheme(theme)
        resolve(theme)
      }, (error) => {
        reject(error)
      })
    })
  }
  createRangedTheme (map, layer, options = {}) {
    return new Promise((resolve, reject) => {
      // region Validation
      if (typeof map === 'undefined') reject('O construtor precisa de uma instância de mapa')
      if (typeof layer === 'undefined') reject('O temático precisa de um alias de layer')
      if (typeof options !== 'object') reject('O temático precisa de opções')
      if (typeof options.layer.featureLayer === 'undefined') reject('Esperado o layer de referência')
      if (typeof options.dataSource.analyticColumn === 'undefined') reject('Esperada a coluna analítica')
      if (typeof options.dataSource.relationalColumn === 'undefined') reject('Esperada a coluna relacional')
      if (typeof options.legend === 'undefined') options.legend.enabled = false
      // endregion

      const dataManager = new DataManager(options)
      dataManager.initialize().then((res) => {
        const theme = new RangedTheme(map, layer, options)
        theme.Buckets = res.buckets
        theme.CustomColor = res.customColors
        theme.DataTable = res.bins
        theme.SetFeatureState(theme.Expression)
        theme.Recompute()
        theme.LegendBuilder.DetachMap()
        theme.DetachMap()
        // self.addTheme(theme)
        resolve(theme)
      }, (error) => {
        reject(error)
      })
    })
  }
  createTheme (map, options = {}) {
    // region Validation
    if (typeof map === 'undefined') reject('O construtor precisa de uma instância de mapa')
    if (typeof options !== 'object') reject('O temático precisa de opções')
    if (typeof options.layer.featureLayer === 'undefined') reject('Esperado o layer de referência')
    if (typeof options.dataSource.analyticColumn === 'undefined') reject('Esperada a expressão')
    if (typeof options.dataSource.relationalColumn === 'undefined') reject('Esperada a coluna relacional')
    if (typeof options.legend === 'undefined') options.legend.enabled = false
    // endregion

    switch (options.classType) {
      case 'IndividualValueTheme':
        return new IndividualValueTheme(map, options.layer.alias, options)
        break

      case 'RangedTheme':
        return new RangedTheme(map, options.layer.alias, options)
        break

      default:
        throw new Error(`Tipo de tema desconhecido: ${options.classType}`)
    }
  }
  getTheme (themeId) {
    if (typeof themeId === 'undefined') throw new Error('Esperado o identificador do temático')
    try {
      const rowIndex = this.store.findIndex(r => r.id === themeId)
      if (rowIndex === -1) return null
      return this.store[rowIndex].theme
    } catch (e) {
      console.log(e)
    }
  }
  removeTheme (themeId) {
    if (typeof themeId === 'undefined') throw new Error('Esperado o identificador do temático')
    try {
      const rowIndex = this.store.findIndex(r => r.id === themeId)
      if (rowIndex === -1) return false
      const theme = this.store[rowIndex].theme
      theme.Destroy()
      this.store.splice(rowIndex, 1)
      theme.EventEmitter.trigger('themeRemoved', {themeId: themeId})
    } catch (e) {
      console.log(e)
    }
  }
}

export { ModifierThemeBin, ThematicBuilder }
